import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';

// import { PagesComponent } from './pages/pages.component';

const routes: Routes = [
  // {path: '', component: PagesComponent},
  { path: '', loadChildren: './pages/pages.module#PagesModule',canActivate:[AuthGuard] },
  {path:'not-found',loadChildren: './not-found/not-found.module#NotFoundModule'}
  // { path: 'pages', loadChildren: () => import('./pages/pages.module').then(mod => mod.PagesModule)  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
